import { faComments, faHistory } from '@fortawesome/pro-light-svg-icons'

import { EntityActivityContainer } from '@domain-group/suit-theme'

import Conversation from '@components/Conversation'

import Activity from './Activity'

import defaultRequestOptions from './defaultRequestOptions'

export const requestOptions = {
  activity: {
    ...defaultRequestOptions.activity,
  },
  conversation: {
    ...defaultRequestOptions.comment,
    ...defaultRequestOptions.conversation,
    ...defaultRequestOptions.image,
    ...defaultRequestOptions.subscriber,
    ...defaultRequestOptions.user,
  },
}

interface EntityActivityProps {
  boxProps: {
    [key: string]: string | number,
  },
  componentSettings?: {
    [key: string]: object,
  },
  subjectId?: number,
  subjectType?: string,
}

const EntityActivity = (props: EntityActivityProps) => {
  const {
    boxProps, componentSettings = {}, subjectId, subjectType,
  } = props

  return (
    <EntityActivityContainer
      boxProps={{
        height: 500,
        marginBottom: 'large',
        ...boxProps,
      }}
      components={{
        activity: {
          icon: faHistory,
          label: 'Activity',
          render: (params: any) => (
            <Activity
              requestOptions={requestOptions.activity}
              {...params}
            />
          ),
        },
        conversation: {
          icon: faComments,
          label: 'Conversation',
          render: (params: any) => {
            const settings = componentSettings.conversation || {}

            return (
              <Conversation
                requestOptions={requestOptions.conversation}
                // @ts-expect-error TS2339
                title={settings.title}
                {...params}
              />
            )
          },
        },
      }}
      defaultSelectedComponentKey="conversation"
      // @ts-expect-error TS2322
      subjectType={subjectType}
      // @ts-expect-error TS2322
      subjectId={subjectId}
    />
  )
}

export default EntityActivity
